var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



// WEBPACK FOOTER //
// ../node_modules/lodash/_getPrototype.js